module.exports = __webpack_public_path__ + "img/SES_205418806.5db5bbf2.jpg";